import {
  getObject,
  getBoolean,
} from "@surya-digital/leo-ts-types";
import { NotApplicableOptionV1 } from "./notApplicableOptionV1";


export namespace GridSingleChoiceDisplayTypeV1 {
  export interface RadioButtonDTO {
    case: string;
  }
  
  export class RadioButton {
    readonly isGridSingleChoiceDisplayTypeV1RadioButton: boolean = true;
  
  
  
  
  
    toDTO(): RadioButtonDTO {
      const dto: RadioButtonDTO = {
        case: "RADIO_BUTTON",
      };
      return dto;
    }
    }
  
  RadioButton.prototype.toString = function toString(): string {
    return `GridSingleChoiceDisplayTypeV1.RADIO_BUTTON()`;
  };
  
  export interface DropdownDTO {
    case: string;
  }
  
  export class Dropdown {
    readonly isGridSingleChoiceDisplayTypeV1Dropdown: boolean = true;
  
  
  
  
  
    toDTO(): DropdownDTO {
      const dto: DropdownDTO = {
        case: "DROPDOWN",
      };
      return dto;
    }
    }
  
  Dropdown.prototype.toString = function toString(): string {
    return `GridSingleChoiceDisplayTypeV1.DROPDOWN()`;
  };
  
  export interface DefaultSliderDTO {
    case: string;
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1DTO;
  }
  
  export class DefaultSlider {
    readonly isGridSingleChoiceDisplayTypeV1DefaultSlider: boolean = true;
  
    readonly notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1;
  
  
    constructor(
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1
    ) {
      this.notApplicableOption = notApplicableOption;
    }
  
    static fromDTO(dto: DefaultSliderDTO): DefaultSlider {
      const notApplicableOption = NotApplicableOptionV1.fromDTO(getObject(dto, "notApplicableOption", InvalidGridSingleChoiceDisplayTypeV1DefaultSliderNotApplicableOptionError));
      return new DefaultSlider(
        notApplicableOption
      );
    }
  
    toDTO(): DefaultSliderDTO {
      const dto: DefaultSliderDTO = {
        case: "DEFAULT_SLIDER",
          notApplicableOption: this.notApplicableOption.toDTO()
      };
      return dto;
    }
    }
  
  DefaultSlider.prototype.toString = function toString(): string {
    return `GridSingleChoiceDisplayTypeV1.DEFAULT_SLIDER(notApplicableOption='${this.notApplicableOption}')`;
  };
  
  export interface RygSliderDTO {
    case: string;
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1DTO;
  }
  
  export class RygSlider {
    readonly isGridSingleChoiceDisplayTypeV1RygSlider: boolean = true;
  
    readonly notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1;
  
  
    constructor(
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1
    ) {
      this.notApplicableOption = notApplicableOption;
    }
  
    static fromDTO(dto: RygSliderDTO): RygSlider {
      const notApplicableOption = NotApplicableOptionV1.fromDTO(getObject(dto, "notApplicableOption", InvalidGridSingleChoiceDisplayTypeV1DefaultSliderNotApplicableOptionError));
      return new RygSlider(
        notApplicableOption
      );
    }
  
    toDTO(): RygSliderDTO {
      const dto: RygSliderDTO = {
        case: "RYG_SLIDER",
          notApplicableOption: this.notApplicableOption.toDTO()
      };
      return dto;
    }
    }
  
  RygSlider.prototype.toString = function toString(): string {
    return `GridSingleChoiceDisplayTypeV1.RYG_SLIDER(notApplicableOption='${this.notApplicableOption}')`;
  };
  
  export interface DefaultScaleDTO {
    case: string;
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1DTO;
  }
  
  export class DefaultScale {
    readonly isGridSingleChoiceDisplayTypeV1DefaultScale: boolean = true;
  
    readonly notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1;
  
  
    constructor(
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1
    ) {
      this.notApplicableOption = notApplicableOption;
    }
  
    static fromDTO(dto: DefaultScaleDTO): DefaultScale {
      const notApplicableOption = NotApplicableOptionV1.fromDTO(getObject(dto, "notApplicableOption", InvalidGridSingleChoiceDisplayTypeV1DefaultSliderNotApplicableOptionError));
      return new DefaultScale(
        notApplicableOption
      );
    }
  
    toDTO(): DefaultScaleDTO {
      const dto: DefaultScaleDTO = {
        case: "DEFAULT_SCALE",
          notApplicableOption: this.notApplicableOption.toDTO()
      };
      return dto;
    }
    }
  
  DefaultScale.prototype.toString = function toString(): string {
    return `GridSingleChoiceDisplayTypeV1.DEFAULT_SCALE(notApplicableOption='${this.notApplicableOption}')`;
  };
  
  export interface ScaleWithTextDTO {
    case: string;
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1DTO;
  }
  
  export class ScaleWithText {
    readonly isGridSingleChoiceDisplayTypeV1ScaleWithText: boolean = true;
  
    readonly notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1;
  
  
    constructor(
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1
    ) {
      this.notApplicableOption = notApplicableOption;
    }
  
    static fromDTO(dto: ScaleWithTextDTO): ScaleWithText {
      const notApplicableOption = NotApplicableOptionV1.fromDTO(getObject(dto, "notApplicableOption", InvalidGridSingleChoiceDisplayTypeV1DefaultSliderNotApplicableOptionError));
      return new ScaleWithText(
        notApplicableOption
      );
    }
  
    toDTO(): ScaleWithTextDTO {
      const dto: ScaleWithTextDTO = {
        case: "SCALE_WITH_TEXT",
          notApplicableOption: this.notApplicableOption.toDTO()
      };
      return dto;
    }
    }
  
  ScaleWithText.prototype.toString = function toString(): string {
    return `GridSingleChoiceDisplayTypeV1.SCALE_WITH_TEXT(notApplicableOption='${this.notApplicableOption}')`;
  };
  
  export interface NeutralScaleDTO {
    case: string;
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1DTO;
  }
  
  export class NeutralScale {
    readonly isGridSingleChoiceDisplayTypeV1NeutralScale: boolean = true;
  
    readonly notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1;
  
  
    constructor(
    notApplicableOption: NotApplicableOptionV1.NotApplicableOptionV1
    ) {
      this.notApplicableOption = notApplicableOption;
    }
  
    static fromDTO(dto: NeutralScaleDTO): NeutralScale {
      const notApplicableOption = NotApplicableOptionV1.fromDTO(getObject(dto, "notApplicableOption", InvalidGridSingleChoiceDisplayTypeV1DefaultSliderNotApplicableOptionError));
      return new NeutralScale(
        notApplicableOption
      );
    }
  
    toDTO(): NeutralScaleDTO {
      const dto: NeutralScaleDTO = {
        case: "NEUTRAL_SCALE",
          notApplicableOption: this.notApplicableOption.toDTO()
      };
      return dto;
    }
    }
  
  NeutralScale.prototype.toString = function toString(): string {
    return `GridSingleChoiceDisplayTypeV1.NEUTRAL_SCALE(notApplicableOption='${this.notApplicableOption}')`;
  };
  
  export interface DefaultNpsDTO {
    case: string;
    isNPSSelectionColored: boolean;
  }
  
  export class DefaultNps {
    readonly isGridSingleChoiceDisplayTypeV1DefaultNps: boolean = true;
  
    readonly isNPSSelectionColored: boolean;
  
  
    constructor(
    isNPSSelectionColored: boolean
    ) {
      this.isNPSSelectionColored = isNPSSelectionColored;
    }
  
    static fromDTO(dto: DefaultNpsDTO): DefaultNps {
      const isNPSSelectionColored = getBoolean(dto, "isNPSSelectionColored", InvalidGridSingleChoiceDisplayTypeV1DefaultNpsIsNpsSelectionColoredError);
      return new DefaultNps(
        isNPSSelectionColored
      );
    }
  
    toDTO(): DefaultNpsDTO {
      const dto: DefaultNpsDTO = {
        case: "DEFAULT_NPS",
          isNPSSelectionColored: this.isNPSSelectionColored
      };
      return dto;
    }
    }
  
  DefaultNps.prototype.toString = function toString(): string {
    return `GridSingleChoiceDisplayTypeV1.DEFAULT_NPS(isNPSSelectionColored='${this.isNPSSelectionColored}')`;
  };
  
  export interface NpsPreFilledColorDTO {
    case: string;
    isNPSSelectionColored: boolean;
  }
  
  export class NpsPreFilledColor {
    readonly isGridSingleChoiceDisplayTypeV1NpsPreFilledColor: boolean = true;
  
    readonly isNPSSelectionColored: boolean;
  
  
    constructor(
    isNPSSelectionColored: boolean
    ) {
      this.isNPSSelectionColored = isNPSSelectionColored;
    }
  
    static fromDTO(dto: NpsPreFilledColorDTO): NpsPreFilledColor {
      const isNPSSelectionColored = getBoolean(dto, "isNPSSelectionColored", InvalidGridSingleChoiceDisplayTypeV1DefaultNpsIsNpsSelectionColoredError);
      return new NpsPreFilledColor(
        isNPSSelectionColored
      );
    }
  
    toDTO(): NpsPreFilledColorDTO {
      const dto: NpsPreFilledColorDTO = {
        case: "NPS_PRE_FILLED_COLOR",
          isNPSSelectionColored: this.isNPSSelectionColored
      };
      return dto;
    }
    }
  
  NpsPreFilledColor.prototype.toString = function toString(): string {
    return `GridSingleChoiceDisplayTypeV1.NPS_PRE_FILLED_COLOR(isNPSSelectionColored='${this.isNPSSelectionColored}')`;
  };
  
  export interface NpsBorderColorDTO {
    case: string;
    isNPSSelectionColored: boolean;
  }
  
  export class NpsBorderColor {
    readonly isGridSingleChoiceDisplayTypeV1NpsBorderColor: boolean = true;
  
    readonly isNPSSelectionColored: boolean;
  
  
    constructor(
    isNPSSelectionColored: boolean
    ) {
      this.isNPSSelectionColored = isNPSSelectionColored;
    }
  
    static fromDTO(dto: NpsBorderColorDTO): NpsBorderColor {
      const isNPSSelectionColored = getBoolean(dto, "isNPSSelectionColored", InvalidGridSingleChoiceDisplayTypeV1DefaultNpsIsNpsSelectionColoredError);
      return new NpsBorderColor(
        isNPSSelectionColored
      );
    }
  
    toDTO(): NpsBorderColorDTO {
      const dto: NpsBorderColorDTO = {
        case: "NPS_BORDER_COLOR",
          isNPSSelectionColored: this.isNPSSelectionColored
      };
      return dto;
    }
    }
  
  NpsBorderColor.prototype.toString = function toString(): string {
    return `GridSingleChoiceDisplayTypeV1.NPS_BORDER_COLOR(isNPSSelectionColored='${this.isNPSSelectionColored}')`;
  };
  

  export type GridSingleChoiceDisplayTypeV1 = RadioButton | Dropdown | DefaultSlider | RygSlider | DefaultScale | ScaleWithText | NeutralScale | DefaultNps | NpsPreFilledColor | NpsBorderColor;

  export type GridSingleChoiceDisplayTypeV1DTO = RadioButtonDTO | DropdownDTO | DefaultSliderDTO | RygSliderDTO | DefaultScaleDTO | ScaleWithTextDTO | NeutralScaleDTO | DefaultNpsDTO | NpsPreFilledColorDTO | NpsBorderColorDTO;

  export const fromDTO = (dto: GridSingleChoiceDisplayTypeV1DTO): GridSingleChoiceDisplayTypeV1 => {
    switch (dto.case) {
      case "RADIO_BUTTON":
          return new RadioButton();
      case "DROPDOWN":
          return new Dropdown();
      case "DEFAULT_SLIDER":
          return DefaultSlider.fromDTO(dto as DefaultSliderDTO);
      case "RYG_SLIDER":
          return RygSlider.fromDTO(dto as RygSliderDTO);
      case "DEFAULT_SCALE":
          return DefaultScale.fromDTO(dto as DefaultScaleDTO);
      case "SCALE_WITH_TEXT":
          return ScaleWithText.fromDTO(dto as ScaleWithTextDTO);
      case "NEUTRAL_SCALE":
          return NeutralScale.fromDTO(dto as NeutralScaleDTO);
      case "DEFAULT_NPS":
          return DefaultNps.fromDTO(dto as DefaultNpsDTO);
      case "NPS_PRE_FILLED_COLOR":
          return NpsPreFilledColor.fromDTO(dto as NpsPreFilledColorDTO);
      case "NPS_BORDER_COLOR":
          return NpsBorderColor.fromDTO(dto as NpsBorderColorDTO);
      default:
        throw new InvalidGridSingleChoiceDisplayTypeV1Error(
            `Case ${dto.case} is not valid case of GridSingleChoiceDisplayTypeV1.`
        );
    }
  };
}

export class InvalidGridSingleChoiceDisplayTypeV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1Error";
  }
}
export class InvalidGridSingleChoiceDisplayTypeV1RadioButtonError extends InvalidGridSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1RadioButtonError";
  }
}

export class InvalidGridSingleChoiceDisplayTypeV1DropdownError extends InvalidGridSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1DropdownError";
  }
}

export class InvalidGridSingleChoiceDisplayTypeV1DefaultSliderError extends InvalidGridSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1DefaultSliderError";
  }
}

export class InvalidGridSingleChoiceDisplayTypeV1DefaultSliderNotApplicableOptionError extends InvalidGridSingleChoiceDisplayTypeV1DefaultSliderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1DefaultSliderNotApplicableOptionError";
  }
}

export class InvalidGridSingleChoiceDisplayTypeV1RygSliderError extends InvalidGridSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1RygSliderError";
  }
}

export class InvalidGridSingleChoiceDisplayTypeV1RygSliderNotApplicableOptionError extends InvalidGridSingleChoiceDisplayTypeV1RygSliderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1RygSliderNotApplicableOptionError";
  }
}

export class InvalidGridSingleChoiceDisplayTypeV1DefaultScaleError extends InvalidGridSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1DefaultScaleError";
  }
}

export class InvalidGridSingleChoiceDisplayTypeV1DefaultScaleNotApplicableOptionError extends InvalidGridSingleChoiceDisplayTypeV1DefaultScaleError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1DefaultScaleNotApplicableOptionError";
  }
}

export class InvalidGridSingleChoiceDisplayTypeV1ScaleWithTextError extends InvalidGridSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1ScaleWithTextError";
  }
}

export class InvalidGridSingleChoiceDisplayTypeV1ScaleWithTextNotApplicableOptionError extends InvalidGridSingleChoiceDisplayTypeV1ScaleWithTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1ScaleWithTextNotApplicableOptionError";
  }
}

export class InvalidGridSingleChoiceDisplayTypeV1NeutralScaleError extends InvalidGridSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1NeutralScaleError";
  }
}

export class InvalidGridSingleChoiceDisplayTypeV1NeutralScaleNotApplicableOptionError extends InvalidGridSingleChoiceDisplayTypeV1NeutralScaleError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1NeutralScaleNotApplicableOptionError";
  }
}

export class InvalidGridSingleChoiceDisplayTypeV1DefaultNpsError extends InvalidGridSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1DefaultNpsError";
  }
}

export class InvalidGridSingleChoiceDisplayTypeV1DefaultNpsIsNpsSelectionColoredError extends InvalidGridSingleChoiceDisplayTypeV1DefaultNpsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1DefaultNpsIsNpsSelectionColoredError";
  }
}

export class InvalidGridSingleChoiceDisplayTypeV1NpsPreFilledColorError extends InvalidGridSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1NpsPreFilledColorError";
  }
}

export class InvalidGridSingleChoiceDisplayTypeV1NpsPreFilledColorIsNpsSelectionColoredError extends InvalidGridSingleChoiceDisplayTypeV1NpsPreFilledColorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1NpsPreFilledColorIsNpsSelectionColoredError";
  }
}

export class InvalidGridSingleChoiceDisplayTypeV1NpsBorderColorError extends InvalidGridSingleChoiceDisplayTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1NpsBorderColorError";
  }
}

export class InvalidGridSingleChoiceDisplayTypeV1NpsBorderColorIsNpsSelectionColoredError extends InvalidGridSingleChoiceDisplayTypeV1NpsBorderColorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleChoiceDisplayTypeV1NpsBorderColorIsNpsSelectionColoredError";
  }
}
